import { fetchFinance, fetchOnlinePay, getMaster, getOnlinePay } from "utils/api";

export const getOnlineMerchantDropdownOptionsApi = async () => {
  return await getMaster("/dropdown-options");
}

export const createOnlineMerchantEntityApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "createMerchants",
    ...params,
  });
};

export const createOnlineMerchantMdrApi = async (params) => {
  return await fetchFinance("/action", {
    action: "addMerchant",
    ...params,
  });
}

export const updateOnlineMerchantProcessorConfigApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "updateProcessorConfig",
    ...params,
  });
}

export const getOnlineMerchantProcessorConfigApi = async (params) => {
  return await getOnlinePay("/merchant/get-processor-config", {
    ...params,
  });
}

export const getOnlineAccountSuspensionRemarksApi = async () => {
  return await getOnlinePay("/merchant/get-suspension-remarks");
}

export const getOnlineMerchantEntityApi = async (params) => {
  return await getOnlinePay("/merchant/detail", {
    ...params,
  });
}

export const getOnlineMerchantMdrApi = async (params) => {
  return await fetchFinance("/action", {
    action: "getMdr",
    ...params,
  });
}

export const updateOnlineMerchantEntityApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "updateMerchants",
    ...params,
  });
};

export const updateOnlineMerchantSettleCurrencyApi = async (params) => {
  return await fetchFinance("/action", {
    action: "updateMerchantCurrency",
    ...params,
  });
}

export const updateOnlineMerchantSettleCurrencyInfoApi = async (params) => {
  return await fetchFinance("/action", {
    action: "updateMerchantSettleCurrency",
    ...params,
  });
}

export const updateOnlineMerchantMdrApi = async (params) => {
  return await fetchFinance("/action", {
    action: "updateMerchant",
    ...params,
  });
}

export const getOnlineEmployeeListApi = async (params) => {
  return await getOnlinePay("/employee/list", {
    sort: "id,desc",
    ...params
  });
}

export const updateOnlineEmployeePasswordApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "employeeChangePass",
    ...params,
  });
}

export const createOnlineEmployeeApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "employeeCreate",
    ...params,
  });
}

export const getOnlineEmployeeDetailApi = async (params) => {
  return await getOnlinePay("/employee/detail", {
    ...params,
  });
}

export const updateOnlineEmployeeDetailApi = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "employeeUpdate",
    ...params,
  });
}